module.exports = __webpack_public_path__ + "img/foodforstudents-logo-dark.688b171c.png";